/**
 * @generated SignedSource<<99b2d46ae209e7f47ae4967481e05b22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditUserInAccountGroupAndAddOrInviteUsersMutationInput = {
  clientMutationId?: string | null;
  emails: ReadonlyArray<string>;
  id: string;
  newName: string;
};
export type editGroupModal_EditUserInAccountGroupAndAddOrInviteUsersMutation$variables = {
  input: EditUserInAccountGroupAndAddOrInviteUsersMutationInput;
  membersConnectionIds: ReadonlyArray<string>;
};
export type editGroupModal_EditUserInAccountGroupAndAddOrInviteUsersMutation$data = {
  readonly AccountMemberManagement: {
    readonly editUserInAccountGroupAndAddOrInviteUsersMutation: {
      readonly group: {
        readonly newInvitations: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly " $fragmentSpreads": FragmentRefs<"membersTab_AccountMemberFragment">;
            };
          } | null> | null;
        };
        readonly " $fragmentSpreads": FragmentRefs<"editGroupSuccessModal_UserInAccountGroupWrapperFragment" | "groupCard_UserInAccountGroupWrapperFragment">;
      } | null;
    } | null;
  };
};
export type editGroupModal_EditUserInAccountGroupAndAddOrInviteUsersMutation = {
  response: editGroupModal_EditUserInAccountGroupAndAddOrInviteUsersMutation$data;
  variables: editGroupModal_EditUserInAccountGroupAndAddOrInviteUsersMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "membersConnectionIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Invitation",
  "kind": "LinkedField",
  "name": "invitation",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "UserInAccountGroup",
  "kind": "LinkedField",
  "name": "groups",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "editGroupModal_EditUserInAccountGroupAndAddOrInviteUsersMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountMemberManagementMutations",
        "kind": "LinkedField",
        "name": "AccountMemberManagement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "EditUserInAccountGroupAndAddOrInviteUsersMutationPayload",
            "kind": "LinkedField",
            "name": "editUserInAccountGroupAndAddOrInviteUsersMutation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInAccountGroupWrapper",
                "kind": "LinkedField",
                "name": "group",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "groupCard_UserInAccountGroupWrapperFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "editGroupSuccessModal_UserInAccountGroupWrapperFragment"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountMemberConnection",
                    "kind": "LinkedField",
                    "name": "newInvitations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AccountMemberEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineDataFragmentSpread",
                                "name": "membersTab_AccountMemberFragment",
                                "selections": [
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "UserInAccount",
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "userContextMenu_UserFragment"
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "UserInAccountWrapper",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v5/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "type": "InvitationWrapper",
                                    "abstractKey": null
                                  },
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "userCard_UserInAccountWrapperFragment"
                                  },
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "invitationCard_InvitationFragment"
                                  }
                                ],
                                "args": null,
                                "argumentDefinitions": []
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "editGroupModal_EditUserInAccountGroupAndAddOrInviteUsersMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountMemberManagementMutations",
        "kind": "LinkedField",
        "name": "AccountMemberManagement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "EditUserInAccountGroupAndAddOrInviteUsersMutationPayload",
            "kind": "LinkedField",
            "name": "editUserInAccountGroupAndAddOrInviteUsersMutation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInAccountGroupWrapper",
                "kind": "LinkedField",
                "name": "group",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "memberCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserInAccountGroup",
                    "kind": "LinkedField",
                    "name": "group",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isBuiltIn",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountMemberConnection",
                    "kind": "LinkedField",
                    "name": "newInvitations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AccountMemberEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v2/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isAccountMember"
                              },
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserInAccount",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v7/*: any*/),
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "userExtensionKind",
                                                "value": "Academies"
                                              }
                                            ],
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "extension",
                                            "plural": false,
                                            "selections": [
                                              (v8/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "firstName",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "lastName",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "File",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "thumbnail",
                                                        "storageKey": null
                                                      },
                                                      (v2/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "sumGamificationPoints",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "AcademiesUserExtension",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": "extension(userExtensionKind:\"Academies\")"
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isManager",
                                    "storageKey": null
                                  },
                                  (v9/*: any*/)
                                ],
                                "type": "UserInAccountWrapper",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v9/*: any*/)
                                ],
                                "type": "InvitationWrapper",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "filters": null,
                        "handle": "appendEdge",
                        "key": "",
                        "kind": "LinkedHandle",
                        "name": "edges",
                        "handleArgs": [
                          {
                            "kind": "Variable",
                            "name": "connections",
                            "variableName": "membersConnectionIds"
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3d9373737111f7f3f1c7e64fd787121d",
    "id": null,
    "metadata": {},
    "name": "editGroupModal_EditUserInAccountGroupAndAddOrInviteUsersMutation",
    "operationKind": "mutation",
    "text": "mutation editGroupModal_EditUserInAccountGroupAndAddOrInviteUsersMutation(\n  $input: EditUserInAccountGroupAndAddOrInviteUsersMutationInput!\n) {\n  AccountMemberManagement {\n    editUserInAccountGroupAndAddOrInviteUsersMutation(input: $input) {\n      group {\n        ...groupCard_UserInAccountGroupWrapperFragment\n        ...editGroupSuccessModal_UserInAccountGroupWrapperFragment\n        newInvitations {\n          edges {\n            node {\n              __typename\n              ...membersTab_AccountMemberFragment\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment editGroupModal_UserInAccountGroupFragment on UserInAccountGroup {\n  id\n  name\n}\n\nfragment editGroupSuccessModal_UserInAccountGroupWrapperFragment on UserInAccountGroupWrapper {\n  memberCount\n  group {\n    name\n    id\n  }\n  newInvitations {\n    edges {\n      node {\n        __typename\n        id\n      }\n    }\n  }\n}\n\nfragment groupCard_UserInAccountGroupWrapperFragment on UserInAccountGroupWrapper {\n  id\n  memberCount\n  group {\n    id\n    name\n    isBuiltIn\n  }\n  ...groupContextMenu_UserInAccountGroupWrapperFragment\n}\n\nfragment groupContextMenu_UserInAccountGroupWrapperFragment on UserInAccountGroupWrapper {\n  group {\n    id\n    name\n    isBuiltIn\n    ...editGroupModal_UserInAccountGroupFragment\n  }\n}\n\nfragment invitationCard_InvitationFragment on AccountMember {\n  __isAccountMember: __typename\n  ... on InvitationWrapper {\n    invitation {\n      id\n      email\n    }\n    groups {\n      id\n      name\n    }\n  }\n}\n\nfragment membersTab_AccountMemberFragment on AccountMember {\n  __isAccountMember: __typename\n  id\n  kind\n  ... on UserInAccountWrapper {\n    user {\n      user {\n        id\n        ...userContextMenu_UserFragment\n      }\n      id\n    }\n  }\n  ... on InvitationWrapper {\n    invitation {\n      id\n      email\n    }\n  }\n  ...userCard_UserInAccountWrapperFragment\n  ...invitationCard_InvitationFragment\n}\n\nfragment userAvatar_UserFragment on User {\n  extension(userExtensionKind: Academies) {\n    __typename\n    ... on AcademiesUserExtension {\n      firstName\n      lastName\n      avatar {\n        thumbnail\n        id\n      }\n      sumGamificationPoints\n    }\n  }\n}\n\nfragment userCard_UserInAccountWrapperFragment on UserInAccountWrapper {\n  id\n  name\n  isManager\n  groups {\n    id\n    name\n  }\n  user {\n    user {\n      id\n      name\n      email\n      ...userAvatar_UserFragment\n    }\n    id\n  }\n}\n\nfragment userContextMenu_UserFragment on User {\n  id\n  name\n  email\n}\n"
  }
};
})();

(node as any).hash = "f46ac627c71bd2ce5dc4ac37b18a2e4c";

export default node;
